<script type="text/javascript">
export default {};
</script>

<template>
  <div class="static-page-loader">
    <div class="static-page-loader__content">
      <div class="static-page-loader__text-1"></div>
      <div class="static-page-loader__text-2"></div>
      <div class="static-page-loader__text-3"></div>
      <br />
      <div class="static-page-loader__text-1"></div>
      <div class="static-page-loader__text-1"></div>
      <div class="static-page-loader__text-1"></div>
      <div class="static-page-loader__text-1"></div>
      <div class="static-page-loader__text-1"></div>
      <div class="static-page-loader__text-1"></div>
      <br />
      <div class="static-page-loader__text-1"></div>
      <div class="static-page-loader__text-1"></div>
      <div class="static-page-loader__text-1"></div>
      <div class="static-page-loader__text-1"></div>
      <div class="static-page-loader__text-1"></div>
      <div class="static-page-loader__text-1"></div>
    </div>
  </div>
</template>

<style lang="scss">
.static-page-loader {
  @import '~styles/settings';

  display: flex;
  align-items: center;
  background: white;

  body[data-theme='dark'] & {
    background: var(--surface-panel);
  }

  &--padding {
    padding: 12px 20px;
  }

  &__content {
    width: 100%;
  }

  &__text-1 {
    margin: 5px 0;

    @include text-line(100%, 15px);
  }

  &__text-2 {
    margin: 5px 0;

    @include text-line(70%, 15px);
  }
  &__text-3 {
    margin: 5px 0;

    @include text-line(50%, 15px);
  }
}
</style>
